'use client';

import React, { useEffect } from 'react';

const Link = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: Link is not implemented yet.');
  }, []);
  return (
    <>
  { /*Link */} 
 </>
  );
};

export default Link;